module.exports = __webpack_public_path__ + "img/CZ00671126.b0d1be10.png";